var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createComponentOverrides } from '../theme/create-component-overrides';
export var createMuiTooltipOverrides = createComponentOverrides(function (_a) {
    var typography = _a.typography, spacing = _a.spacing, tokens = _a.tokens;
    return ({
        defaultProps: {
            arrow: true,
        },
        styleOverrides: {
            tooltip: __assign(__assign({}, typography.caption), { fontWeight: typography.fontWeightMedium, color: tokens.color_fg_inverse, backgroundColor: tokens.color_bg_layer_boldest, padding: spacing(1, 1.5) }),
            arrow: {
                color: tokens.color_bg_layer_boldest,
            },
        },
    });
});
